import publicApi from './publicApi';
import api from './api';

const API_URL = '/actualites';

export const getPublicActualites = async (options = {}) => {
  const perPage = options.limit ?? options.perPage ?? 12;
  const response = await publicApi.get('/public/actualites', {
    params: { per_page: perPage, page: options.page ?? 1 },
  });
  const payload = response.data;
  if (Array.isArray(payload)) return payload;
  return payload.data ?? [];
};

export const getPublicActualite = async (id) => {
  const response = await publicApi.get(`/public/actualites/${id}`);
  return response.data;
};

/** Liste courte (accueil public) ou première page sans tout charger. */
export const getActualites = async (options = {}) => {
  try {
    const perPage = options.limit ?? options.perPage ?? 3;
    const response = await api.get(API_URL, {
      params: { per_page: perPage, page: options.page ?? 1 },
    });
    const payload = response.data;
    if (Array.isArray(payload)) {
      return payload;
    }
    return payload.data ?? [];
  } catch (error) {
    console.error('Erreur lors de la récupération des actualités:', error);
    throw error;
  }
};

/** Pagination admin (réponse Laravel complète). */
export const getActualitesPaginated = async (page = 1, perPage = 12) => {
  try {
    const response = await api.get(API_URL, {
      params: { page, per_page: perPage },
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des actualités:', error);
    throw error;
  }
};

export const createActualite = async (actualiteData) => {
  try {
    const response = await api.post(API_URL, actualiteData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la création de l\'actualité:', error);
    throw error;
  }
};

export const updateActualite = async (id, actualiteData) => {
  try {
    const response = await api.put(`${API_URL}/${id}`, actualiteData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour de l\'actualité:', error);
    throw error;
  }
};

export const deleteActualite = async (id) => {
  try {
    await api.delete(`${API_URL}/${id}`);
  } catch (error) {
    console.error('Erreur lors de la suppression de l\'actualité:', error);
    throw error;
  }
};
